//@ts-nocheck
import React, { useEffect, useMemo, useState } from "react";

import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { classNames } from "../../../utils/classNames";
import { useNavigate, useSearchParams } from "react-router-dom";
import CreateIcon from "../../../Icons/Create";
import DownloadIcon from "../../../Icons/DownloadIcon";
import UploadIcon from "../../../Icons/UploadIcon";
import { downloadApiData } from "../../../helpers/AxiosInstance";
import useGetHook from "../../../customHooks/useNotificationServiceGetHook";
import moment from "moment";
import Spinner from "../Spinner";
// import AddIcons from "../../../assets/icons/addIcon.svg";

interface IDataTable {
  url: string;
  queryKey: string;
  columns: any;
  addNewPagePath?: string;
  tableName: string;
  params?: any;
  scanComponent?: any;
  actionMenu?: any;
  setRerender?: any,
  isUpload?: boolean
  isDownload?: boolean
}

function DataTable(props: IDataTable) {
  const { url, queryKey, columns: tableColumns, addNewPagePath, scanComponent, actionMenu, params: otherParams, isUpload = false, isDownload = false } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    "limit": "10",
    "page": "0",
    "searchQuery": "",
  })
  const [limit, setLimit] = useState(10);
  const page = parseInt(searchParams.get("page"));
  const searchQuery = searchParams.get("searchQuery")
  const checkedAllItems = searchParams.get("selectAllItems") === "1"
  const navigate = useNavigate();


  const { data: serverData, isLoading } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${page}-${searchQuery}-${JSON.stringify(otherParams)}`],
    url: url,
    params: {
      limit: limit,
      offset: limit * page,
      search: searchQuery,
      ...otherParams,
    },
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    if (Array.isArray(serverData?.results)) {
      setData([...serverData?.results] ?? []);
      if (searchParams.get("selectAllItems") === "1") {
        let _newItems = serverData?.results?.map(item => item.id).join(",").toString()
        setSearchParms({ "page": page, "selectedItems": _newItems, "selectAllItems": searchParams.get("selectAllItems"), "searchQuery": searchQuery });
      }
    }
  }, [serverData]);


  const handleSelectAll = (table) => {
    const { options: { data: tableData } } = table
    const isSelected = searchParams.get("selectAllItems")
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData?.map(item => item.id).join(",").toString()
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  }


  const handleIndividualSelect = (value) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return
    }
    let itemIndex = selectedItems?.findIndex(item => item === value)
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems")
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value)
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  }

  const isSelected = (value) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems) {
      return false
    }
    return selectedItems.includes(value)
  }


  isDownload && tableColumns.splice(
    0, 1,
    {
      id: 'select',
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className='cursor-pointer'
          />
        )
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className='cursor-pointer'
        />
      ),
    },
  )


  const columns = useMemo(() => [
    ...tableColumns
  ], [tableColumns])


  // Create the table and pass your options
  const table = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const handleAddPageRoute = () => {
    navigate(addNewPagePath);
  };

  useEffect(() => {
    table.setPageSize(limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  const handleNextPage = () => {
    searchParams.set("page", page + 1);
    setSearchParms(searchParams);
  };

  const handlePreviousPage = () => {
    searchParams.set("page", page - 1);
    setSearchParms(searchParams);
  };

  const handleLastpage = () => {
    searchParams.set("page", Math.floor(serverData?.count / limit));
    setSearchParms(searchParams);
  };

  const handleFirstPage = () => {
    searchParams.set("page", 0);
    setSearchParms(searchParams);
  };

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value,);
    searchParams.set("page", 0,);
    setSearchParms(searchParams);
  }

  const handleDownloadExcel = async () => {
    try {
      await downloadApiData(`${url}download-excel/`, `${queryKey}-${moment().format('MMMM-Do-YYYY-h-mm-ss')}.xlsx`)
    } catch (e) {
      console.log(e)
    }
  };

  const handleUploadExcel = () => {
    navigate("bulk-upload")
  }

  if (isLoading) {
    return (
      <Spinner />
    )
  }

  return (
    <>
      {addNewPagePath &&
        <>
          <div className="w-full flex justify-between">
            <button
              onClick={handleAddPageRoute}
              className="p-2 flex gap-x-2 bg-[#FFBBDC] my-2 rounded text-primary"
            >
              <CreateIcon color={"var(--primary)"} />
              Add New
            </button>
            {scanComponent}
          </div>
        </>
      }
      <div
        className="w-full bg-white rounded-sm mb-8"
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div className="w-full grid grid-cols-1 gap-4 md:flex justify-between p-4">
          <div>
            <input
              type="text"
              placeholder="Search"
              onChange={(e) => handleSearch(e?.target?.value)}
              className="border w-full border-1 border-primary focus:outline-none p-1"
            />
          </div>
          <div className="text-primary w-full justify-end flex gap-x-4">
            <span
              className="flex gap-x-1 w-full cursor-pointer"
            >
              {actionMenu}
            </span>
            {isDownload &&
              <span
                className="flex gap-x-1 cursor-pointer"
                onClick={handleDownloadExcel}
              >
                <DownloadIcon color={"var(--primary)"} />
                Download
              </span>
            }
            {isUpload &&
              <span
                className="flex gap-x-1 cursor-pointer"
                onClick={handleUploadExcel}
              >
                <UploadIcon color={"var(--primary)"} />
                Upload
              </span>
            }

            {/* <span
              className="flex gap-x-1 cursor-pointer"
              onClick={handleNotImplemented}
            >
              <DownloadPDFIcon color={"var(--primary)"} />
              Print
            </span> */}
          </div>
        </div>
        <div className="w-full overflow-auto">
          <table className="w-full">
            <thead className="bg-primary text-white uppercase">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="">
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={classNames(
                        index === 0
                          ? ""
                          : headerGroup.headers?.length - 1 === index
                            ? " text-left w-[8rem]"
                            : "",
                        "py-[5px] text-left px-5 whitespace-nowrap"
                      )}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className="even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all"
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="py-[10px] text-left px-5">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              {table.getFooterGroups().map((footerGroup) => (
                <tr key={footerGroup.id}>
                  {footerGroup.headers.map((header) => (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.footer,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
        <div className="flex bg-white py-2 my-4 w-full justify-center gap-4">
          <button
            className="border hidden md:block rounded p-1"
            onClick={() => handleFirstPage()}
            disabled={!serverData?.previous}
          >
            {"<<"}
          </button>
          <button
            className="border rounded p-1"
            onClick={() => handlePreviousPage()}
            disabled={!serverData?.previous}
          >
            {"<"}
          </button>
          <button
            className="border rounded p-1"
            onClick={() => handleNextPage()}
            disabled={!serverData?.next}
          >
            {">"}
          </button>
          <button
            className="border hidden md:block rounded p-1"
            onClick={() => handleLastpage()}
            disabled={!serverData?.next}
          >
            {">>"}
          </button>
          <span className="flex items-center gap-1">
            <div>Page</div>
            <strong>
              {page + 1} of {Math.ceil(serverData?.count / limit)}
            </strong>
          </span>
          {/* <span className="flex items-center gap-1">
              | Go to page:
              <input
                type="number"
                min={1}
                value={page}
                max={Math.ceil(serverData?.count/limit)}
                onChange={e => {setPage(Number(e.target.value))}}
                className="border p-1 rounded w-16"
              />
            </span> */}
          <select
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              searchParams.set("limit", e?.target?.value,);
              setSearchParms(searchParams)

            }}
          >
            {[10, 50, 100, 200, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <p className="mt-1">All: {serverData?.count}</p>
        </div>
      </div>
    </>
  );
}

export default DataTable;
